module.exports = __webpack_public_path__ + "img/hu3.0bdfc522.png";